import { createContext, type Dispatch } from 'react';

import {
    type ReducerState,
    type ReducerActions,
    blankState,
} from './SellerApplicationFormReducer.ts';

const SellerOmtReturnReviewContext = createContext<{
    dispatch: Dispatch<ReducerActions>;
    state: ReducerState;
}>({
    dispatch: () => {},
    state: blankState,
});

export default SellerOmtReturnReviewContext;
